<script>
  export let flagship_sheets_list;
</script>

<div class="theme_content">
  <div class="theme_content_item">
    {#each flagship_sheets_list as flagship_product, i}
      <div class="item_box item_box_{i}">
        <div class="box_inside">
          <div class="box_top">
            <div class="content_video">
              <div class="imgBox" style="height: 100%">
                {#if flagship_product.video_link}
                  <iframe
                    title
                    width="100%"
                    height="100%"
                    frameborder="0"
                    scrolling="yes"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope;
                    picture-in-picture"
                    allowfullscreen
                    src={flagship_product.video_link} />
                {:else}
                  {#if flagship_product.left_tag}
                    <div class="left_tags">{flagship_product.left_tag}</div>
                  {/if}
                  {#if flagship_product.right_tag}
                    <div class="right_tags">{flagship_product.right_tag}</div>
                  {/if}
                  <div class="photo" style="background-image: url('{flagship_product.photo_link}'); background-size: cover; background-position: center center; background-repeat: no-repeat;">
                  </div>
                {/if}
              </div>
            </div>
            <div class="content_desc">
              <div class="flagship_title">
                <h4>{flagship_product.introduction_focus}</h4>
              </div>
              <h6>{flagship_product.introduction_title}</h6>
              <div class="hotel_detail_area">
                <div class="feature_area">
                  {#each flagship_product.content_after_split as content}
                    <p>{content}</p>
                  {/each}
                </div>
                <div class="price_area">
                {#if flagship_product.origin_price}
                    <span>原價 <span class="origin_price">${flagship_product.origin_price}</span></span>
                    <br />
                {/if}
                  <span style="font-size: 14px; color: #777777;">NT$</span>
                  <span
                    class="current_price">{flagship_product.current_price}</span>
                  <span style="font-size: 14px; color: #777777;">起</span>
                </div>
              </div>
              <a
                class="buy_hotel_btn"
                href={flagship_product.buy_product_link}
                target="_blank"
                title={flagship_product.introduction_title}>
                馬上搶購
              </a>
            </div>
          </div>
          <slot product_index={i} />
        </div>
      </div>
    {/each}
  </div>
</div>
